export const SWYCHR_MARKETS = [
  { countryCode: 'CM', currency: 'XAF', label: 'Cameroon' },
  { countryCode: 'KE', currency: 'KES', label: 'Kenya' },
  { countryCode: 'GA', currency: 'XAF', label: 'Gabon' },
  { countryCode: 'CD', currency: 'CDF', label: 'Congo DRC' },
  { countryCode: 'SN', currency: 'XOF', label: 'Senegal' },
  { countryCode: 'CI', currency: 'XOF', label: "Cote D'Ivoire" },
  { countryCode: 'BF', currency: 'XOF', label: 'Burkina Faso' },
  { countryCode: 'ML', currency: 'XOF', label: 'Mali' },
  { countryCode: 'BJ', currency: 'XOF', label: 'Benin' },
  { countryCode: 'TG', currency: 'XOF', label: 'Togo' },
  { countryCode: 'TZ', currency: 'TZS', label: 'Tanzania' },
  { countryCode: 'UG', currency: 'UGX', label: 'Uganda' },
  { countryCode: 'NG', currency: 'NGN', label: 'Nigeria' },
  { countryCode: 'NE', currency: 'XOF', label: 'Niger' },
  { countryCode: 'RW', currency: 'RWF', label: 'Rwanda' },
  { countryCode: 'CG', currency: 'XAF', label: 'Congo Brazzaville' },
  { countryCode: 'GN', currency: 'GNF', label: 'Guinea Conakry' },
  { countryCode: 'GH', currency: 'GHS', label: 'Ghana' },
];

export function getSwychrMarketByCountry(countryCode) {
  const normalized = String(countryCode || '').trim().toUpperCase();
  return SWYCHR_MARKETS.find((market) => market.countryCode === normalized) || null;
}
